import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;
export const apiClient = axios.create({ baseURL: API });
export const getToken = () => localStorage.getItem("cw_admin_token");
export const setToken = (t) => localStorage.setItem("cw_admin_token", t);
export const clearToken = () => { apiClient.post("/admin/logout").catch(() => {}); localStorage.removeItem("cw_admin_token"); };
export const authHeaders = () => { const t = getToken(); return t ? { Authorization: `Bearer ${t}` } : {}; };
export const photoImageUrl = (id) => `${API}/photos/${id}/image`;
export const photoThumbUrl = (id, size = 800) => `${API}/photos/${id}/thumb?size=${size}`;
export const videoStreamUrl = (id) => `${API}/videos/${id}/stream`;
export const photoSrc = (photo) => photo.thumb_url || photoThumbUrl(photo.id, 1200);
export const statementImageSrc = (s) => s.image_url || photoThumbUrl(s.image_id, 1200);
export const videoSrc = (v) => v.stream_url || videoStreamUrl(v.id);
const _cache = new Map();
export const cachedGet = async (path, onData) => {
  if (_cache.has(path)) onData(_cache.get(path));
  const res = await apiClient.get(path);
  _cache.set(path, res.data);
  onData(res.data);
  return res.data;
};
